import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Select,
  Radio,
  InputNumber,
  Slider,
  Checkbox,
} from 'antd'
import { FilterFilled } from '@ant-design/icons'
import FilterList from './fullfilment.filterlist'
import _ from 'lodash'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import util from '../../util/util'
import { constants } from '../../constants'
import moment from 'moment'
import { getFullfillments, getFullfillmentsCount } from '../../store/action/device.action'
import { getCustomersIdAndNameList } from '../../store/action/customer.action'

const { Option } = Select
var form = null

const FullfilmentFilter = (props) => {
  const [open, setOpen] = useState(false)
  const [customerList, setCustomerList] = useState([])
  var history = useHistory()

  useEffect(() => {
    handleModalOpen()
    props.getCustomersIdAndNameList({
      companyId: props.companyId,
      healthCoachId: '',
    })
  }, [open])

  useEffect(() => {
    const userList = props.customer.customers?.map((customer) => ({
      value: customer.id,
      label: customer.name,
    }))
    setCustomerList(userList)
  }, [props.customer])

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      var values = _.pickBy(data, _.identity)
      let filter = props.fullfillmentFilter
      values.lastname_plain
        ? (filter.lastname_plain = values.lastname_plain)
        : delete filter.lastname_plain
      values.consent !== undefined
        ? (filter.consent = values.consent)
        : delete filter.consent
      values.registered !== undefined
        ? (filter.registered = values.registered)
        : delete filter.registered
      values.isnew !== undefined 
        ? (filter.isnew = values.isnew)
        : delete filter.isnew
      values.customer && (filter.customer = values.customer);
      values.type=values.type?filter.type=values.type:filter.type='active'

      values.type !== undefined
        ? (filter.type = values.type)
        : filter.type='active'
      props.getFullfillmentsCount(filter?.type)
      props.getFullfillments(
        {
          filters: filter,
          metadata: { pageSize: 20, current: 1 },
          sorter: { field: 'orderDate', order: 'descend' },
        },
        {}
      )

      setOpen(false)
    })
  }
  var handleClearFilter = () => {
    let filter = props.fullfillmentFilter
    filter?.lastname_plain && delete filter.lastname_plain
    filter?.customer && delete filter.customer
    filter?.consent && delete filter.consent
    filter?.registered && delete filter.registered
    filter?.type && delete filter.type
    filter?.isnew && delete filter.isnew
    props.getFullfillments(
      {
        filters: filter,
        metadata: { pageSize: 20, current: 1 },
        sorter: { field: 'orderDate', order: 'descend' },
      },
      {}
    )
    props.getFullfillmentsCount()
    form && form.resetFields()
    if (history.location.state && history.location.state.patientids) {
      let state = { ...history.location.state }
      delete state.patientids
      history.replace({ ...history.location, state })
    }
  }

  var handleModalOpen = () => {
    var data = { ...props.fullfillmentFilter }
    console.log('QSW', props.fullfillmentFilter, form)
    form &&
      form.setFieldsValue({
        ...data,
      })
  }

  var renderCard = () => {
    return (
      <Card bordered={false}>
        <Form
          ref={(e) => (form = e)}
          name='normal_login'
          layout='horizontal'
          // initialValues={defaultValue}
          labelCol={{ span: 7 }}
        >
          <Form.Item name='customer' label='Clinic'>
            <Select
              placeholder='Select clinic name'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {customerList.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name='lastname_plain' label='Last Name'>
            <Input type='lastname_plain' placeholder='Enter Last Name' />
          </Form.Item>
          <Form.Item name='consent' label='Consent'>
            <Radio.Group>
              <Radio value={1}>Yes</Radio>
              <Radio value={2}>No</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name='registered' label='Registered Patient'>
            <Radio.Group>
              <Radio value={1}>Yes</Radio>
              <Radio value={2}>No</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name='isnew' label='Fullfillment Type'>
            <Radio.Group>
              <Radio value={1}>Reorder</Radio>
              <Radio value={2}>New</Radio>
            </Radio.Group>
          </Form.Item>          
          <Form.Item name='type' label='Patient Type'>
          <Radio.Group buttonStyle='solid' defaultValue='active'>
               <Radio.Button value='active'>Active</Radio.Button>
               <Radio.Button value='inactive'>Inactive</Radio.Button>
           </Radio.Group>
         </Form.Item>
        </Form>
      </Card>
    )
  }

  return (
    <>
      <Row className='filterRow' align={'end'}>
        <Col flex={'auto'}>
          <FilterList
            filters={props.fullfillmentFilter}
            customers={customerList}
          />
        </Col>
        <Col flex={'30%'}>
          <Row justify={'end'}>
            <Button
              className={'clearBtn'}
              type='primary'
              onClick={handleClearFilter}
              disabled={props.filters && Object.keys(props.filters).length <= 1}
            >
              Clear Filter
            </Button>
            <FilterFilled
              className={'filterIcon'}
              onClick={() => {
                setOpen(true)
              }}
            />
          </Row>
        </Col>
      </Row>
      <Modal
        className={'filterModal'}
        visible={open}
        closable={false}
        maskClosable={false}
        width={'50%'}
        okText={'Filter'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

FullfilmentFilter.propTypes = {
  companyId: PropTypes.string,
  fullfillmentFilter: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    companyId: state.profile?.company?._id,
    decoded: util.verifyToken(state.profile.token, true),
    user: state.profile?.user,
    fullfillmentFilter: state.device.fullfillmentFilter,
    customer: state.customer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getFullfillments: (params) => dispatch(getFullfillments(params)),
    getFullfillmentsCount: (type) => dispatch(getFullfillmentsCount(type)),
    getCustomersIdAndNameList: (params) => {
      dispatch(getCustomersIdAndNameList(params))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullfilmentFilter)
